// extracted by mini-css-extract-plugin
export default {"trigger":"LargeScreenMenu_trigger__MaBHP","button":"LargeScreenMenu_button__EbLBU","popover":"LargeScreenMenu_popover__pvLPq"};